import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = () => {
    switch (status?.toLowerCase()) {
      case 'success':
        return {
          icon: 'CheckCircle',
          text: 'Success',
          className: 'bg-success/10 text-success border-success/20'
        };
      case 'failed': case'error':
        return {
          icon: 'XCircle',
          text: 'Failed',
          className: 'bg-error/10 text-error border-error/20'
        };
      case 'pending':
        return {
          icon: 'Clock',
          text: 'Pending',
          className: 'bg-warning/10 text-warning border-warning/20'
        };
      case 'warning':
        return {
          icon: 'AlertTriangle',
          text: 'Warning',
          className: 'bg-warning/10 text-warning border-warning/20'
        };
      default:
        return {
          icon: 'Circle',
          text: status || 'Unknown',
          className: 'bg-muted text-muted-foreground border-border'
        };
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-sm';
      default:
        return 'px-3 py-1.5 text-xs';
    }
  };

  const config = getStatusConfig();

  return (
    <span className={`
      inline-flex items-center space-x-1.5 rounded-full border font-medium transition-colors
      ${config?.className} ${getSizeClasses()}
    `}>
      <Icon name={config?.icon} size={size === 'lg' ? 16 : 12} />
      <span>{config?.text}</span>
    </span>
  );
};

export default StatusBadge;

